// @import dependencies
import { store } from 'app_storage/redux-storage'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {UserInfoModuleLayout} from 'app_components/modules/campus/user/userInfo'
// @end

// @import events
// @end

// @import utils
// @end

// @INFO Import types
import {IUserInfo} from 'app_types/campus/user/userInfoTypes'
// @end


// @import services
import UserDataService from 'app_services/campus/user/userService'
// @end

// @import types
// @end

// @ADD Component types
interface IUserInfoModuleProps {
  className?: string
  hideCertifications?: boolean
  showEditButton?: boolean
  showChangePassword?: boolean
  id?: string
}
interface IUserInfoModuleState {
  status: null | 'loading' | 'error'
  userInfo: IUserInfo | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class UserInfoModule extends Component<IUserInfoModuleProps, IUserInfoModuleState> {

  private userDataService: UserDataService
  private storeObject: any

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IUserInfoModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      userInfo: null
    }

    this.storeObject = store
    this.userDataService = new UserDataService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchUserInfo()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onUserUpdated = async (data: any) => {
    if (data?.status === true) {
      await this.fetchUserInfo()
    }
  }

  fetchUserInfo = async () => {
    let user = this.storeObject?.getState().auth?.user?.data
    if (user && user.id) {
      const userDataInfoResponse = await this.userDataService.fetchUserInfo(user.id)

      if (userDataInfoResponse && userDataInfoResponse.status === 'success') {
        let userInfo: any = {...userDataInfoResponse.user}
        if (userInfo?.certifications && Array.isArray(userInfo?.certifications)) {
          userInfo.certifications = userInfo.certifications.sort((a: any, b: any) => {
            const date1 = new Date(a.date)
            const date2 = new Date(b.date)
            if (date1 < date2) {
              return 1;
            }
            if (date1 > date2) {
              return -1;
            }
            return 0
          })
        }
        this.setState({userInfo: userInfo})
      }
      this.setState({status: null})
    }
  }

  render() {
    return(
      <UserInfoModuleLayout
        status={this.state.status}
        userInfo={this.state.userInfo}
        onUserUpdated={this.onUserUpdated}
        className={this.props.className}
        hideCertifications={this.props.hideCertifications}
        showEditButton={this.props.showEditButton}
        showChangePassword={this.props.showChangePassword}
        id={this.props.id}
      />
    )
  }
}

export default connect(mapStatesToProps)(UserInfoModule)
